import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';

class AddToCartModal extends React.Component {
  render() {
    const handleClose = this.props.handleClose;
    const product = this.props.product;
    const quantity = this.props.quantity;
    return (
      <div className="added-to-bag-modal">
        <Modal.Header closeButton>
          <Modal.Title>This item was added to your bag.</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="added-to-bag-details">
            <p>{product.name}</p>
            <p>${product.price}</p>
            <p>Quantity: {quantity}</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button as={Link} to="/shopping-cart" variant="success">
            VIEW BAG
          </Button>
          <Button as={Link} to="/shopping-cart" variant="success">
            CHECKOUT
          </Button>
          <Button variant="success" onClick={handleClose}>
            KEEP SHOPPING
          </Button>
        </Modal.Footer>
      </div>
    );
  }
}

export default AddToCartModal;
